import { useAuth } from 'contexts/auth';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Loading } from 'shell/components';

const LTILaunchPage = () => {
    const { auth } = useAuth();
    const history = useHistory();

    useEffect(() => {
        if (!auth) return;

        if (['instructor', 'ta', 'student'].includes(auth.role)) {
            const hasCanvasApiToken = Boolean(localStorage.getItem('access_token'));
            const needsCanvasApiToken = ['instructor', 'ta'].includes(auth.role);

            if (needsCanvasApiToken && !hasCanvasApiToken) {
                if (auth.course_id) {
                    localStorage.setItem('course_id', auth.course_id);
                }

                sessionStorage.setItem('lti_oauth_after_launch', 'true');
                sessionStorage.setItem('lti_oauth_return_path', '/assignments');
                window.location.href = '/api-launch';
                return;
            }

            history.replace('/assignments');
            return;
        }

        history.replace('/');
    }, [auth, history]);

    return <Loading />;
};

export default LTILaunchPage;
